var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapIcon = function SvgMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4B4F54",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.312 20.342c.31 0 .59-.156.777-.405l5.442-7.742c0-.031.032-.031.032-.062a7.46 7.46 0 0 0 1.057-3.826c0-1.96-.747-3.793-2.146-5.162S12.21 1 10.281 1c-1.96 0-3.794.745-5.162 2.145a7.376 7.376 0 0 0-1.057 8.988c0 .03.03.03.03.062l5.473 7.742c.156.25.436.405.747.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.31 11.758A3.196 3.196 0 0 1 7.123 8.57a3.197 3.197 0 0 1 3.187-3.188 3.196 3.196 0 0 1 3.186 3.188 3.196 3.196 0 0 1-3.186 3.187Z"
  }))));
};
export default SvgMapIcon;